import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getCountriesListingController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/country-code",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getCountriesListingController >> ", err.message);
        return err.response
    }
}

export const getCitiesListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/city",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getCitiesListing >> ", err.message);
        return err.response
    }
}

export const getAreasListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/areas",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getAreasListing >> ", err.message);
        return err.response
    }
}

export const addAreaController = async (cityId, area) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/areas",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: { cityId, area }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addBabaySitterExperienceController >> ", err.message);
        return err.response
    }
}

export const removeAreaController = async (id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + `/v1/admin/area/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in deleteCityController >> ", err.message);
        return err.response
    }
}

export const addCityController = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/city",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addCityController >> ", err.message);
        return err.response
    }
}

export const deleteCityController = async (id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + `/v1/admin/city/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in deleteCityController >> ", err.message);
        return err.response
    }
}

/* Nona Fee controller */
export const addNonaFeesController = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/nona-fee",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addNonaFeesController >> ", err.message);
        return err.response
    }
}

export const getNonaFeesController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/nona-fee",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getNonaFeesController >> ", err.message);
        return err.response
    }
}

export const removeNonaFee = async (_id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + "/v1/admin/nona-fee/"+_id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getNonaFeesController >> ", err.message);
        return err.response
    }
}

export const getCountryCitiesListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/country-city",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getCountryCitiesListing >> ", err.message);
        return err.response
    }
}

/* Promo code controllers */
export const addPromoCode = async (data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/promo-code",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const promoCodeLisiting = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/promo-code",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
      
        return err.response
    }
}

export const removePromoCode = async (_id) => {
    try {
        const config = {
            method: 'DELETE',
            url: BASE_URL + "/v1/admin/promo-code/"+_id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
      
        return err.response
    }
}